/**
 * Formats a number as currency with thousands separators and 2 decimal places.
 *
 * @example toCurrency(1234.56)                       // "$1,234.56"
 * @example toCurrency(-1234.56)                      // "-$1,234.56"
 * @example toCurrency(1234.56, { showSign: true })   // "+$1,234.56"
 * @example toCurrency(-1234.56, { showSign: false }) // "-$1,234.56"
 */
export default function toCurrency(value: number | string, args?: { showSign?: boolean }): string {
  const { showSign = false } = args ?? {};
  const num = typeof value === 'string' ? parseFloat(value) : value;
  const absValue = Math.abs(num);
  const sign = showSign ? (num < 0 ? '-' : num > 0 ? '+' : '') : num < 0 ? '-' : '';
  const formatted = absValue.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${sign}$${formatted}`;
}
